import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { Link } from 'react-router-dom';

// Style
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const directorySources = {
  'google-directory': 'Google',
  'azure-active-directory': 'Microsoft Azure',
};

function DirectoryMapping({ mappings }) {
  const classes = useStyles();
  const [showMore, setShowMore] = useState(false);

  const onClick = () => {
    setShowMore(!showMore);
  };

  const renderTableRows = () => {
    return mappings.map((mapping, index) => {
      let tableRowClasses = classes.tableRow;
      if (index !== mappings.length - 1) {
        tableRowClasses = classNames(classes.tableRow, classes.tableRowBorder);
      }

      if (!showMore && mappings.length >= 3 && index !== 2) {
        tableRowClasses = classNames(classes.tableRow, classes.tableRowBorder);
      }

      return (
        <div className={tableRowClasses} key={index}>
          <div className={classes.tableCell} title={mapping.label}>
            {mapping.label}
          </div>
          <div className={classes.tableCell} title={directorySources[mapping.type] || mapping.type}>
            {directorySources[mapping.type] || mapping.type}
          </div>
          <div className={classes.tableCell} style={{ textAlign: 'right' }}>
            <Link to={`/admin/directories/${mapping.id}`} data-testid={`${mapping.id}-link`}>
              <Button color="primary" className={classes.blue}>
                View Directory
              </Button>
            </Link>
          </div>
        </div>
      );
    });
  };

  const renderTable = () => {
    const minRows = mappings.length >= 3 ? 3 : mappings.length;
    const tableRowHeight = minHeight + borderHeight;
    const tableHeight = showMore ? tableRowHeight * mappings.length : tableRowHeight * minRows;

    return (
      <div className={classes.table}>
        <div className={classes.tableRow}>
          <div className={classNames(classes.tableHeader, classes.tableCell)}>Directory</div>
          <div className={classNames(classes.tableHeader, classes.tableCell)}>Sourced From</div>
          <div className={classNames(classes.tableHeader, classes.tableCell)} />
        </div>
        <div className={classes.tableContent} style={{ height: tableHeight }}>
          {renderTableRows()}
        </div>
      </div>
    );
  };

  let buttonRowElem = null;
  if (mappings.length > 3) {
    buttonRowElem = (
      <div className={classes.tableButtonRow}>
        <Button onClick={onClick}>
          {showMore ? 'Show Less' : `Show ${mappings.length - 3} More`}
        </Button>
      </div>
    );
  }

  return (
    <CardContent>
      <div>{renderTable()}</div>
      <div>{buttonRowElem}</div>
    </CardContent>
  );
}

const minHeight = 46;
const borderHeight = 1;
const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  table: {
    margin: theme.spacing(2, 3, 1, 3),
  },
  tableHeader: {
    fontSize: 14,
    fontWeight: 600,
  },
  tableContent: {
    transition: 'height .3s',
    flow: 'hidden',
  },
  tableCell: {
    width: 145,
    padding: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
    flex: '1 1 auto',
  },
  tableRow: {
    display: 'flex',
    minHeight: minHeight,
    alignItems: 'center',
  },
  tableRowBorder: {
    borderBottom: `1px solid ${theme.colors.divider}`,
  },
  tableButtonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  blue: {
    color: theme.palette.secondary.main,
  },
}));

DirectoryMapping.propTypes = {
  mappings: PropTypes.array.isRequired,
};

export default DirectoryMapping;
